import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ProductGrid from '../components/ProductGrid';
import BookAppointment from '../components/BookAppointment';
import CollectionGrid from '../components/CollectionGrid';
import FinancingSection from '../components/FinancingSection';
import ResponsibleSourcing from '../components/ResponsibleSourcing';
import Testimonials from '../components/Testimonials';
import Mission from '../components/Mission';
import BlogSection from '../components/BlogSection';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import NewsletterPopup from '../components/NewsletterPopup';
import { Toaster } from '../components/ui/toaster';
import { fetchProducts } from '../services/api';
import { products as mockProducts } from '../mockData';

const Home = () => {
  const [newArrivals, setNewArrivals] = useState([]);
  const [inStockProducts, setInStockProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const engagementProducts = await fetchProducts('engagement', 12);
        const instockProducts = await fetchProducts('instock');
        
        setNewArrivals(engagementProducts);
        setInStockProducts(instockProducts);
      } catch (error) {
        console.error('Failed to fetch products, using mock data:', error);
        // Fallback to mock data
        setNewArrivals(mockProducts.filter(p => p.category === 'engagement').slice(0, 12));
        setInStockProducts(mockProducts.filter(p => p.category === 'instock'));
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-gray-300 border-t-gray-800 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <div id="new-arrivals">
        <ProductGrid products={newArrivals} title="New Arrivals" />
      </div>
      <BookAppointment />
      <div id="collections">
        <CollectionGrid />
      </div>
      <FinancingSection />
      <div id="in-stock">
        <ProductGrid products={inStockProducts} title="Shop our In Stock Lab Grown Diamond Engagement Rings" />
      </div>
      <ResponsibleSourcing />
      <div id="testimonials">
        <Testimonials />
      </div>
      <Mission />
      <div id="blog">
        <BlogSection />
      </div>
      <div id="newsletter">
        <Newsletter />
      </div>
      <Footer />
      <NewsletterPopup />
      <Toaster />
    </div>
  );
};

export default Home;